module.exports = __webpack_public_path__ + "static/media/nuxtjs.c69c9970.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-alternatives/images/nuxtjs.png
// module id = 972
// module chunks = 0